<!-- @format -->

<shared-ceops></shared-ceops>

<main
  id="app-container"
  class="family-container"
  role="main">
  <router-outlet></router-outlet>

  <plp-components-product-list-snackbar></plp-components-product-list-snackbar>

  @if (compareCheckboxEnabled()) {
    <hmf-drawer
      #drawer
      [className]="'plp-compare-drawer-wrapper'"
      [noPadding]="true"
      [direction]="drawerDirection()"
      [headerText]="'Product Comparison'"
      [mobilePeek]="true"
      [size]="drawerSize()"
      (closed)="onDrawerClosed()">
      @if (isCompareGridOpen()) {
        <compare-components-compare-grid
          class="compare-grid-drawer-layout"
          [compareProductDetails]="compareProductDetails()"
          [compareBarProducts]="compareBarProducts()"
          [compareProductsAvailability]="compareProductsAvailability()"
          [compareGridLoading]="isProductDataLoading()"
          [compareGridApiFailed]="hasApiFailed()"
          (productRemoved)="plpCompareService.removeProductFromCompareList($event)"
          (closeCompareGrid)="plpCompareService.closeCompareGrid()"
          (tryAgainClicked)="plpCompareService.retryLastProductDetailsFetch()">
        </compare-components-compare-grid>
      }
    </hmf-drawer>
  }
</main>
